import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import * as React from 'react';

import Dropdown from 'ui-library/dropdowns/Dropdown';

export default function OverflowDropdown({
  menu,
  icon,
  isOpen,
  onToggle,
}: {
  menu: JSX.Element;
  icon: JSX.Element;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
}): JSX.Element {
  return (
    <Dropdown
      className={classNames(css(styles.dropdown), 'dropdown-menu--dropLeft')}
      closeOnInsideClick={true}
      closeOnOutsideClick={true}
      menu={menu}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      {icon}
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  dropdown: {
    width: 195,
  },
});
